module.exports = __webpack_public_path__ + "img/weddings_30_V.0b5aa116.webp";